module.exports = __webpack_public_path__ + "static/media/Lesson-2-12-The-Holy-Spirit-Belongs-to-us.ce53e938.pdf";